import { FunderSettings } from './funder-settings';
import { User } from './user';

export class Funder {
  funder_code!: string;
  funder_name!: string;
  details?: string;
  street_address?: string;
  city?: string;
  country?: string;
  phone_number?: string;
  email?: string;
  bank_name?: string;
  bank_code?: string;
  bank_branch?: string;
  bank_account_name?: string;
  bank_account_number?: string;
  bank_swift_code?: string;
  management_fee_percentage_per_claim!: number;
  management_fee_amount_per_claim_line!: number;
  logo_path?: string;
  primary_color!: string;
  date_joined?: number;
  date_approved?: number;
  status!: string;
  date_deleted?: number;
  user_uuid!: string;
  uuid!: string;
  date_created!: number;
  date_updated!: number;

  user?: User;
  funder_settings?: FunderSettings;

  isPending() {
    return this.status.toLocaleLowerCase() == 'pending';
  }

  isApproved() {
    return this.status.toLocaleLowerCase() == 'approved';
  }

  isSuspended() {
    return this.status.toLocaleLowerCase() == 'suspended';
  }

  isTerminated() {
    return this.status.toLocaleLowerCase() == 'terminated';
  }

  constructor(data: any) {
    this.funder_code = data.funder_code;
    this.funder_name = data.funder_name;
    this.details = data.details;
    this.street_address = data.street_address;
    this.city = data.city;
    this.country = data.country;
    this.phone_number = data.phone_number;
    this.email = data.email;
    this.date_joined = data.date_joined;
    this.bank_name = data.bank_name;
    this.bank_code = data.bank_code;
    this.bank_branch = data.bank_branch;
    this.bank_account_name = data.bank_account_name;
    this.bank_account_number = data.bank_account_number;
    this.bank_swift_code = data.bank_swift_code;
    this.management_fee_percentage_per_claim =
      data.management_fee_percentage_per_claim;
    this.management_fee_amount_per_claim_line =
      data.management_fee_amount_per_claim_line;
    this.logo_path = data.logo_path;
    this.primary_color = data.primary_color;
    this.date_approved = data.date_approved;
    this.status = data.status;
    this.date_deleted = data.date_deleted;
    this.user_uuid = data.user_uuid;
    this.uuid = data.uuid;
    this.date_created = data.date_created;
    this.date_updated = data.date_updated;

    if (data.user) {
      this.user = new User(data.user);
    }
    if (data.funder_settings) {
      this.funder_settings = new FunderSettings(data.funder_settings);
    }
  }
}
